import { Button, ButtonProps } from "@faire/web/slate/Button";
import { Color } from "@faire/web/slate/Color";
import * as React from "react";
import styled from "styled-components";

interface IActionBase {
  text: string;
}

interface IActionALink extends IActionBase {
  action: { href: string; to?: never; onClick?: () => void };
}

interface IActionLink extends IActionBase {
  action: { href?: never; to: string; onClick?: () => void };
}

interface IActionButton extends IActionBase {
  action: { href?: never; to?: never; onClick: () => void };
}

export type IAction = IActionALink | IActionLink | IActionButton;

export const renderTextAction = (
  actionOptions?: IAction,
  options?: { textColor?: Color }
) => {
  if (!actionOptions) {
    return null;
  }

  return (
    <Button
      tertiaryColor={options?.textColor}
      variant="tertiary"
      onClick={actionOptions.action.onClick}
      linkTo={actionOptions.action.href ?? actionOptions.action.to}
      target={actionOptions.action.href ? "__blank" : undefined}
    >
      {actionOptions.text}
    </Button>
  );
};

export const renderButtonAction = (actionOptions?: IAction) => {
  if (!actionOptions) {
    return null;
  }

  return (
    <Button
      onClick={actionOptions.action.onClick}
      linkTo={actionOptions.action.href ?? actionOptions.action.to}
      target={actionOptions.action.href ? "__blank" : undefined}
    >
      {actionOptions.text}
    </Button>
  );
};

/**
 * @deprecated Use `@faire/web/slate/Button` with `variant="tertiary"` and `tertiaryColor` prop
 * @supersededBy "@faire/web/slate/Button/Button#Button"
 * @trackcomponent
 * */
export const ColoredButton = styled(Button)<ButtonProps & { color?: Color }>`
  color: ${(props) => props.color};
  text-decoration-color: ${(props) => props.color};
`;
